import React, { Fragment, useState } from 'react'
import { object, array, func, bool, string } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { EMPTY_OBJECT, DEFAULT_FUNC } from '../../../utils/constants'
import Icon from '../../ui/icon/Icon'
import ListItem from '../../ui/list/ListItem'
import { isMobileAgent } from '../../../helpers/common'
import withMouseMenuAim from '../../../hoc/withMouseMenuAim'

const FIRST_COLUMN_LIMIT = 10
const SECOND_COLUMN_LIMIT = 21

export const BigTreeList = React.forwardRef(({
  messages = EMPTY_OBJECT,
  onClickItem,
  onMainCategoryClick,
  filteredData = [EMPTY_OBJECT],
  renderNoMatchQuery,
  twoLevelsCat,
  handleMouseEnterOption = DEFAULT_FUNC,
  titleKey = 'mainCategories',
  activeSubcategory
}, ref) => {
  const [slugActiveItem, setSlugActiveItem] = useState(activeSubcategory || filteredData[0].slug)

  const onChangeListItemEvent = slug => {
    if (slug === slugActiveItem) {
      return
    }
    setSlugActiveItem(slug)
  }

  const renderSubCategories = () => {
    const categoriesOrder = []

    // remove next const when backend returns a sorted subcategories list
    const sortedSubCategories = activeCategory && activeCategory.sub_categories.sort((a, b) => {
      b.sub_categories = b.sub_categories || []
      a.sub_categories = a.sub_categories || []
      return b.sub_categories.length - a.sub_categories.length
    })
    sortedSubCategories.map(item => {
      item.sub_categories = item.sub_categories || []
      categoriesOrder.push({
        ...item,
        isFirstSubcategory: true,
        classes: classnames({ 'ad-list__item--sub-categories': !twoLevelsCat })
      })
      return item.sub_categories.map(subItem => categoriesOrder.push({ ...subItem, classes: 'ad-list__item--sub-sub-categories' }))
    })

    let gridOrderIndex = -1
    return categoriesOrder.map((item, index) => {
      item.sub_categories = item.sub_categories || []
      const subcategorySize = item.sub_categories.length + 1

      if (item.isFirstSubcategory && subcategorySize <= 11) {
        // Check whether the whole subcategory fits in the column. If not, it's forced to move to the next column
        const shouldBeFirstColumn = gridOrderIndex <= FIRST_COLUMN_LIMIT
        const shouldBeSecondColumn = gridOrderIndex > FIRST_COLUMN_LIMIT && gridOrderIndex <= SECOND_COLUMN_LIMIT
        const lastChildrenTentativeSlot = gridOrderIndex + subcategorySize
        if (shouldBeFirstColumn && lastChildrenTentativeSlot > FIRST_COLUMN_LIMIT) {
          gridOrderIndex = FIRST_COLUMN_LIMIT
        } else if (shouldBeSecondColumn && lastChildrenTentativeSlot > SECOND_COLUMN_LIMIT) {
          gridOrderIndex = SECOND_COLUMN_LIMIT
        }
      }
      gridOrderIndex = gridOrderIndex + 1
      const gridArea = `cat-column-${gridOrderIndex}`
      return (
        <ListItem
          listItemProps={{ style: { gridArea } }}
          customClass={item.classes}
          item={item}
          index={index}
          onClick={(...args) => onClickItem(...args, activeCategory)}
          key={item.name + index}
        />
      )
    })
  }

  const subMenuClasses = classnames('ad-filter__content--full', {
    'ad-filter--submenu-active': activeSubcategory
  })

  const activeCategory = filteredData.find(cat => cat.slug === slugActiveItem)
  const activeCategoryHasSubcategories = activeCategory && activeCategory.sub_categories && !!activeCategory.sub_categories.length
  return (<Fragment>
    {<div
      className='ad-filter__content--single ad-filter__content--single-large'>
      <span className='ad-filter__title'><FormattedMessage {...messages[titleKey]} /></span>
      {filteredData.length > 0
        ? (
          <ul ref={ref}>{filteredData.slice(0, 13).map((item, index) => {
            const onClickProp = onMainCategoryClick ?? (isMobileAgent() ? () => onChangeListItemEvent(item.slug) : onClickItem)
            return (
              <ListItem
                customClass='ad-list__item--main-categories'
                item={item}
                index={index}
                onMouseEnter={() => handleMouseEnterOption(() => onChangeListItemEvent(item.slug))}
                onClick={onClickProp}
                key={item.name + index}
              >
                {activeCategory.slug === item.slug && activeCategoryHasSubcategories ? <Icon svg='rightChevron' /> : null}
              </ListItem>
            )
          })}
          </ul>
        )
        : <div className='ad-filter__text'>{renderNoMatchQuery}</div>}
    </div>}
    {slugActiveItem && activeCategoryHasSubcategories && (
      <div className={subMenuClasses}>
        <span className='ad-filter__title'>
          {activeCategory.name}
        </span>
        <ul className='ad-list__subcategories-box'>
          {renderSubCategories()}
        </ul>
      </div>
    )}
  </Fragment>
  )
})
BigTreeList.propTypes = {
  messages: object,
  onClickItem: func,
  onMainCategoryClick: func,
  filteredData: array,
  renderNoMatchQuery: object,
  handleMouseEnterOption: func,
  twoLevelsCat: bool,
  titleKey: string,
  activeSubcategory: string
}

export default withMouseMenuAim(BigTreeList)
